import './loggedOut.css';

export default function ServicesSummary() {
    return (
        <section id="our-services" className="landing-services scene scene--sand py-6">
            <div className="container">
                <div className="section-head">
                    <h3 className="mb-3">Our Services</h3>
                    <p className="mb-0">
                        Explore our range of supports designed to match your goals and interests.
                    </p>
                </div>
                <div className="services-grid">
                    {serviceSummaries.map((service) => (
                        <a
                            className="service-tile"
                            key={service.title}
                            href={service.href}
                            style={{ backgroundColor: service.color }}
                        >
                            <div className="service-media">
                                <img src={service.image} alt={service.title} />
                            </div>

                            <div className="service-body">
                                <h5 style={{ fontWeight: 600, marginBottom: "0.5rem" }}>
                                    {service.title}
                                </h5>
                                <p className="small mb-0" style={{ color: "#4f5e69", lineHeight: 1.6 }}>
                                    {service.desc}
                                </p>
                            </div>

                            <span className="service-link">-&gt;</span>
                        </a>
                    ))}
                </div>

            </div>
        </section>
    )

}

const serviceSummaries = [
    {
        title: "In home Support",
        desc: "Support in the home tailored to individual goals.",
        href: "/OurServices/InHomeSupport",
        image: "/marketing_images/services/in_home_support.jpg",
        color: "#FFD1DC"
    },
    {
        title: "Accessible Eats",
        desc: "Inclusive cooking & life skills program.",
        href: "/OurServices/AccessibleEats",
        image: "/marketing_images/services/accessible_eats.jpg",
        color: "#89CFF0"
    },
    {
        title: "Crafternoon",
        desc: "Creative crafting & social connection.",
        href: "/OurServices/Crafternoon",
        image: "/marketing_images/services/crafternoons.jpg",
        color: "#98FF98"
    },
    {
        title: "Community Outdoor Access",
        desc: "Outdoor & community participation supports.",
        href: "/OurServices/CommunityOutdoorAccess",
        image: "/marketing_images/services/community_outdoor_access.jpg",
        color: "#E6E6FA"
    },
    {
        title: "Respite",
        desc: "Short stay, home-away-from-home support.",
        href: "/OurServices/Respite",
        image: "/marketing_images/services/respite_house.jpg",
        color: "#FFFACD"
    },
    {
        title: "Neuro Pathways",
        desc: "Tailored tutoring & educational support.",
        href: "/OurServices/neuroPathways",
        image: "/marketing_images/services/neuropathways.jpg",
        color: "#FFDAB9"
    },
    {
        title: "Tuesday Social",
        desc: "Weekly social & community engagement.",
        href: "/OurServices/TuesdaySocial",
        image: "/marketing_images/services/social_tuesday.png",
        color: "#AFEEEE"
    },
    {
        title: "Tactical Minds",
        desc: "Games-based social & skill building.",
        href: "/OurServices/TacticalMinds",
        image: "/marketing_images/services/tactical_minds.png",
        color: "#C8A2C8"
    }
];
